import { render, staticRenderFns } from "./ReclameAquiPercentageOfComplaintsResolved.container.vue?vue&type=template&id=265fd172&"
import script from "./ReclameAquiPercentageOfComplaintsResolved.container.vue?vue&type=script&lang=ts&"
export * from "./ReclameAquiPercentageOfComplaintsResolved.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports